import React, { useState, useEffect } from "react";
import { Modal,Form } from "antd";

import {
    ExclamationOutlined,
  } from "@ant-design/icons";

const ModalConfirmarRemocao = ({ visible, onCancel, onConfirm, colaborador }) => {
  const [justificativa, setJustificativa] = useState("");
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      setJustificativa("");
      form.resetFields();
    }
  }, [visible, form]);

  const handleOk = async () => {
    try {
      /*const values = await form.validateFields();*/
      onConfirm();
    } catch (error) {
      // validação falhou, não faz nada
    }
  };

  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ExclamationOutlined style={{ color: "#faad14", fontSize: 20 }} />
          <strong><span>Atenção</span></strong>
        </div>
      }
      onOk={handleOk}
      onCancel={onCancel}
      okText="Sim, Remover"
      cancelText="Cancelar"
      okButtonProps={{ danger: true }}
    >
      <p>
        Deseja realmente excluir o segurado{" "}
        <strong>{colaborador?.nome || "selecionado"}</strong> da lista?
      </p>
      {/*<Form form={form} layout="vertical">
        <Form.Item
          name="justificativa"
          label="Justificativa"
          rules={[{ required: true, message: "Por favor, informe a justificativa." }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Digite a justificativa para a remoção"
          />
        </Form.Item>
      </Form>*/}
    </Modal>
  );
};

export default ModalConfirmarRemocao;
